import { isNil, max } from 'ramda'

type Limited = { threshold: number }
type Countable = { currentValue: number }
type Toggable = { isEnabled: boolean }

type Status = 'allowed' | 'forbidden' | 'disabled' | 'loading'

export const getQuota = <T extends Limited>(counter?: T) =>
  counter ? counter.threshold : 0

export const getUsed = <T extends Countable>(counter?: T) =>
  counter ? counter.currentValue : 0

export const getRemaining = <T extends Limited & Countable>(counter?: T) =>
  max(getQuota(counter) - getUsed(counter), 0)

export const getIsExceeded = <T extends Limited & Countable>(counter?: T) =>
  getRemaining(counter) <= 0

export const getStatus = (counter?: Limited & Countable & Toggable): Status => {
  if (!isNil(counter) && counter.isEnabled && !getIsExceeded(counter))
    return 'allowed'
  if (!isNil(counter) && counter.isEnabled && getIsExceeded(counter))
    return 'forbidden'
  if (!isNil(counter) && !counter.isEnabled) return 'disabled'
  return 'loading'
}
